import { render, staticRenderFns } from "./jln_standard.vue?vue&type=template&id=09ea4b17&"
import script from "./jln_standard.vue?vue&type=script&lang=js&"
export * from "./jln_standard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports